import React from 'react'
import { J1LeftarrowC, J2Add, J2Editacontent, J2Userprofile, K1Blindness } from '@e3dc-react/icons'

export const pageActionIcons = {
  user: <J2Userprofile />,
  back: <J1LeftarrowC />,
  edit: <J2Editacontent />,
  add: <J2Add />,
  service: <K1Blindness />,
  custom: <J2Add />,
}
